<template>
    <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card class="box no-display">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Leaving Certificate </strong>
          <v-icon @click="onload" title="Reload list" dark color="yellow"
            >mdi-reload</v-icon
          >
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center">
        <v-col cols="12" sm="4" md="4" class="mt-3">
          <v-combobox
            class="no-display"
            v-model="registration_no"
            @change="checkHistory"
            :loading="comp_load"
            rounded
            :items="stud_list"
            label="Select Student"
            item-text="name"
            outlined
            dense
            prepend-icon="mdi-account-child-circle"
          ></v-combobox>
        </v-col>
      </v-row>
      <div v-if="registration_no != null">
        <template>
          <v-expansion-panels class="expapanel no-display mb-6" focusable inset>
            <v-expansion-panel>
              <v-expansion-panel-header class="panelheader"
                >Account History
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <v-data-table
                  :headers="headers_1"
                  :items="ay_record"
                  class="elevation-1 mytable"
                  dense
                >
                  <template v-slot:item.status="{ item }">
                    <v-chip :color="getColor(item.status)" dark>
                      {{ item.status }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-expansion-panels class="expapanel no-display" focusable inset>
            <v-expansion-panel>
              <v-expansion-panel-header class="panelheader"
                >Academic History
              </v-expansion-panel-header>
              <v-expansion-panel-content class="mt-5">
                <!-- table content -->

                <v-data-table
                  :headers="headers_2"
                  :items="ay_record_div"
                  dense
                  class="elevation-1 mytable"
                >
                </v-data-table>
                <!-- table end -->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>

        <!-- radio button -->
        <v-row justify="center" dense class="no-display">
          <v-radio-group
            v-model="fetch_gen_toggle"
            mandatory
            row
            class="radiobtn"
          >
            <v-radio label="Fetch LC" value="FETCH"></v-radio>
            <v-radio label="Generate LC" value="GENERATE"></v-radio>
          </v-radio-group>
        </v-row>
        <!-- radio button end -->
        <v-row justify="center" v-if="ay_record.length != 0">
          <div class="fees no-display">
            <span v-if="account_status" style="color: #4caf50"
              >Fees Clear
            </span>
            <span v-else style="color: #f44336">Fees Pending</span>
          </div>
        </v-row>
      </div>
    </v-card>
    <div v-if="registration_no != null">
      <!-- generate lc code -->
      <template v-if="fetch_gen_toggle == 'GENERATE'">
        <!-- Date starts -->
        <v-row justify="center" class="mt-3">
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                dense
                v-model="last_date_of_school"
                @blur="date = parseDate(last_date_of_school)"
                v-on="on"
                hint="Last Date of Leaving"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              no-title
              @input="menu1 = false"
            ></v-date-picker>
          </v-menu>

          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                dense
                v-model="gen_date"
                @blur="date = parseDate(gen_date)"
                v-on="on"
                hint="Generation Date"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date2"
              no-title
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu>
          <v-menu
            ref="menu4"
            v-model="menu4"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                dense
                v-model="application_date"
                @blur="date = parseDate(application_date)"
                v-on="on"
                hint="Date Of Application"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date_of_application"
              no-title
              @input="menu4 = false"
              @change="setToText()"
            ></v-date-picker>
          </v-menu>
          <v-menu
            ref="menu3"
            v-model="menu3"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-bind="attrs"
                dense
                v-model="issue_date"
                @blur="date = parseDate(issue_date)"
                v-on="on"
                hint="Date Of Issue"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              label="Issue Date"
              v-model="date_of_issue"
              no-title
              @input="menu3 = false"
              @change="setToText2()"
            ></v-date-picker>
          </v-menu>
        </v-row>
        <!-- Date ends -->
        <v-row justify="center" class="mt-3">
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="progress"
              rounded
              :items="dvt_prog"
              label="Select Progress"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="conduct"
              rounded
              :items="dvt_conduct"
              label="Select Conduct"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="remark"
              rounded
              :items="dvt_remark"
              label="Select Remark"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <v-combobox
              v-model="reason"
              rounded
              :items="dvt_reason"
              label="Select Reason"
              outlined
              dense
              persistent-hint
            ></v-combobox>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-3">
          <v-checkbox
            color="#0f2027"
            v-model="mark_inactive"
            label="Do You Want To Mark Student Inactive After Generating LC.?"
          ></v-checkbox>
        </v-row>
        <v-row justify="center">
          <v-btn @click="genLC" :disabled="!condition">Generate LC</v-btn>
        </v-row>
      </template>
      <!-- generate lc code end -->
      <template v-if="fetch_gen_toggle == 'FETCH'">
        <v-btn class="button no-display" @click="fetchLC">Fetch LC</v-btn>
        <br />
      </template>
        <div id="document1" class="printdiv" v-if="lc_data != null">
            <v-row>
                <v-col cols="4" sm="4" md="4" class="mt-5">
                <center>
                    <img
                    :src="org_basic_data.school_logo"
                    alt="school_logo"
                    height="150px"
                    width="190px"                    
                    />
                </center>
                </v-col>
                <v-col cols="7" sm="7" md="7">
                <center>
                    <p>{{ org_basic_data.trust_name }}</p>
                    <h1 class="header-style">
                    Sanjivani <span class="span-first-letter">I</span>nternational <span class="span-first-letter">S</span>chool
                    </h1>
                    <p>{{ org_basic_data.address }}</p>
                    <span class="tdata2 mr-12">Phone: {{ org_basic_data.phone }}</span> <span class="tdata2">Email: {{ org_basic_data.email }}</span>
                    <h1 class="heading">LEAVING CERTIFICATE</h1>
                </center>
                </v-col>
            </v-row>
            <hr style="border: 1px solid rgb(151, 17, 17);">
            <center><p>(No change in any entry in this certificate shall be made except the authority issuing it and
                infringement of this requirement is liable in involve the imposition of penalty such as that of rustication.)
            </p></center>
            <hr style="border: 1px solid rgb(151, 17, 17);">
            <v-row dense class="ml-2">
                <v-col cols="4" sm="4" md="4"><b>L.C. No. </b> {{ lc_data.certificate_no }}</v-col>
                <v-spacer></v-spacer>
                <v-col cols="4" sm="4" md="4"><b>G. R. No. </b> {{ lc_data.gr_number }}</v-col>
            </v-row>
            <hr style="border: 1px solid rgb(151, 17, 17);">
            <v-row dense class="ml-2">
                <!-- <v-col cols="4" sm="4" md="4"><b>Sr. No. </b></v-col> -->
                <v-spacer></v-spacer>
                <v-col cols="4" sm="4" md="4"><b>School Code: </b> 31194</v-col>
            </v-row>
            <div class="row line-height" style="padding: 0px 18px">
                <div>
                    <b>1) Full Name of Pupil - </b><span class="underline" style="width: 812px;"> {{ lc_data.fullname }}</span>
                </div>
                <div>
                    <b>2) Father's Name -  </b><span class="underline" style="width: 849px;"> {{ lc_data.father_full_name }}</span>
                </div>
                <div>
                    <b>3) Mother's Name -  </b><span class="underline" style="width: 842px;"> {{ lc_data.mother_first_name }}</span>
                </div>
                <div>
                    <b>4) Religion & Caste  - </b><span class="underline" style="width: 828px;"> {{ lc_data.religion }} - {{ lc_data.caste }}</span>
                </div>
                <div>
                    <b>5) Whether candidate belongs to <br> 
                    <span class="ml-5"> Scheduled Tribe or Other Background Communities - </span> </b><span class="underline" style="width: 517px;"> {{ lc_data.subcaste }}</span>
                </div>
                <div>
                    <b>6) Place of Birth  - </b><span class="underline" style="width: 851px;"> {{ lc_data.birth_place }}</span>
                </div>
                <div>
                    <b>7) Date of Birth (in Christian Era) <br> 
                    <span class="ml-5">in Figure & Words - </span></b><span class="underline" style="width: 814px;"> {{ lc_data.dob_fig }} ({{ lc_data.dob_words }})</span>
                </div>          
                <div>
                    <b>8) Nationality  - </b><span class="underline" style="width: 871px;"> {{ lc_data.nationality }}</span>
                </div>
                <div>
                    <b>9) Date of first admission in the School with class -  </b><span class="underline" style="width: 547px;"> {{ lc_data.doa }} ({{ lc_data.admittedstandard }})</span>
                </div>
                <div>
                    <b>10) Class in which the pupil last studied in words & figure  - </b><span class="underline" style="width: 478px;"> {{ lc_data.standard }} ({{ lc_data.std_in_words }})</span>
                </div>
                <div>
                    <b>11) School / Board Annual Examination last taken with result -  </b><span class="underline" style="width: 451px;"> {{ lc_data.last_school }}</span>
                </div>
                <div>
                    <b>12) Whether qualified for promotion to higher class if so, <br>
                    <span class="ml-5">to which class - </span></b><span class="underline" style="width: 844px;">{{ is_promoted_to_next_standard.name }} 
                    <span v-if="is_promoted_to_next_standard.name == 'Yes'">
                    ({{ promoted_standard.standard }})
                    </span></span>
                </div>
                <div>
                    <b>13) Whether NCC Cadet/Boy-Scout/Girl-Guide  - </b><span class="underline" style="width: 578px;"> {{ whether_ncc_cadet }}</span>
                </div>
                <div>
                    <b>14) General Conduct -  </b><span class="underline" style="width: 806px;"> {{ lc_data.conduct }} </span>
                </div>
                <div>
                    <b>15) Date of application for certificate -  </b><span class="underline" style="width: 660px;"> {{ lc_data.date_of_application }}</span>
                </div>
                <div>
                    <b>16) Date of issue of certificate -  </b><span class="underline" style="width: 720px;"> {{ lc_data.date_of_issue }}</span>
                </div>
                <div>
                    <b>17) Reason for Leaving the school -  </b><span class="underline" style="width: 688px;"> {{ lc_data.reason }}</span>
                </div>
                <div>
                    <b>18) Remarks -  </b><span class="underline" style="width: 877px;"> {{ lc_data.remark }}</span>
                </div>
                <div class="mb-2">
                    <b>19) Full Name of the Principal -  </b><span class="underline" style="width: 725px;"> {{ lc_data.principal_name }}</span>
                </div>
            </div>
            <hr style="border: 1px solid rgb(151, 17, 17);">
            <div class="pl-3">
            <p>Certified that the above information is in accordance with the General Register of the school.</p>
            <p>Place: <span style="font-weight: 400;">{{ org_basic_data.address }}</span></p>
            <p>Date: <span style="font-weight: 400;">{{ lc_data.gen_date }}</span></p>
            </div>
            <br><br><br>
            <v-row class="f-size">
                <v-col cols="4" sm="4" md="4" align="center"><b> Prepared by </b></v-col>
                <v-col cols="4" sm="4" md="4" align="center"><b> Class Teacher </b></v-col>
                <v-col cols="4" sm="4" md="4" align="center"><b> Principal </b></v-col>
            </v-row>
        </div>
    </div>
    <div class="no-display" v-if="lc_data != null">
      <div style="text-align: center">
        ----------------------------------Modify------------------------------------
      </div>
      <br />

      <v-row justify="center" class="mt-3">
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Student Progress"
            v-model.trim="lc_data.progress"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Conduct"
            v-model.trim="lc_data.conduct"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Student Remark"
            v-model.trim="lc_data.remark"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Student Reason"
            v-model.trim="lc_data.reason"
          ></v-text-field>
        </v-col>        
      </v-row>
      <v-row justify="center">
        <v-btn class="mb-2 button" color="warning" @click="savegenLC()" small
          >Save</v-btn
        >
      </v-row>
      <hr />
      <v-row class="no-display">
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Birth in words"
            v-model.trim="lc_data.dob_words"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Last School"
            v-model.trim="lc_data.last_school"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Standard"
            v-model.trim="lc_data.standard"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Since when..."
            v-model.trim="lc_data.standard_since_when"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Caste"
            v-model.trim="lc_data.caste"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <v-text-field
            label="Religion"
            v-model.trim="lc_data.religion"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <span>Is Promoted To Next Standard</span>
          <v-combobox
            v-model="is_promoted_to_next_standard"
            rounded
            :items="is_promoted_to_standard"
            label="Select Option"
            item-value="name"
            item-text="name"
            @change="setnextstandard(is_promoted_to_next_standard)"
            outlined
            dense
            persistent-hint
          ></v-combobox>
        </v-col>
        <v-col
            cols="12"
            sm="3"
            md="3"
              v-if="show_promoted_standards == true"
            >
            <span>Select Standard To Which Student Will Promoted</span>
              <v-combobox
                v-model="promoted_standard"
                rounded
                :items="standard_list"
                label="Select Standard"
                item-value="standard"
                item-text="standard"
                outlined
                dense
                persistent-hint
              ></v-combobox>
        </v-col>
        <v-col cols="12" sm="3" md="3">
            <v-text-field
              label="Whether NCC Cadet/Boy Scout/ Girl Guide"
              v-model.trim="whether_ncc_cadet"
            ></v-text-field>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-btn @click="proceed" class="info">Proceed to print</v-btn>
      </v-row>
    </div> 
    </div>   
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
      data() {
    return {
      mark_inactive: false,
      headers_1: [
        { text: "Academic Year", value: "ay" },
        { text: "Paid", value: "paid" },
        { text: "Balance", value: "balance" },
        { text: "Status", value: "status" },
      ],
      headers_2: [
        { text: "Academic Year", value: "ay" },
        { text: "Roll No", value: "rollno" },
        { text: "Div", value: "div" },
        { text: "Std", value: "std" },
        { text: "Total", value: "total" },
        { text: "Present ", value: "present" },
      ],

      comp_load: false,
      fetch_loader: false,
      overlay: false,
      snackbar: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      registration_no: null,
      stud_list: [],
      ay_record: [],
      ay_record_div: [],
      account_status: false,
      dvt_prog: [],
      progress: null,
      dvt_conduct: [],
      conduct: null,
      dvt_reason: [],
      reason: null,
      dvt_remark: [],
      remark: null,
      fetch_gen_toggle: "FETCH",
      board_toggle: "SSC",
      //////date
      last_date_of_school: "",
      gen_date: "",
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      date_of_application: new Date().toISOString().substr(0, 10),
      date_of_issue: new Date().toISOString().substr(0, 10),
      application_date: "",
      issue_date: "",
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      nowDate: new Date().toISOString().slice(0, 10),
      ///
      lc_data: null,
      org_basic_data: null,
      condition: false,
      org_id: null,
      whether_ncc_cadet: "",
      is_promoted_to_next_standard: "",
      promoted_standard: "",
      is_promoted_to_standard: [
        { name: "Yes", id: "1" },
        { name: "No", id: "2" },        
      ],
      standard_list: [],
      promoted_standard_in_words: "",
      show_promoted_standards: false,
    };
  },
  watch: {
    date(val) {
      this.last_date_of_school = this.formatDate(this.date);
    },
    date2(val) {
      this.gen_date = this.formatDate(this.date2);
    },
    date_of_application(val) {
      this.application_date = this.formatDate(this.date_of_application);
      this.lc_data.date_of_application = this.application_date;
    },
    date_of_issue(val) {
      this.issue_date = this.formatDate(this.date_of_issue);
      this.lc_data.date_of_issue = this.issue_date;
    },
  },
  methods: {
    setToText() {
      this.lc_data.date_of_application = this.application_date;
    },
    setToText2() {
      this.lc_data.date_of_issue = this.issue_date;
    },
    setnextstandard(item) {
     //  alert("item::"+item.name)
      if (item.name == "Yes") {
        this.show_promoted_standards = true;
        this.promoted_standard = this.lc_data.nextstandard;
        this.promoted_standard_in_words = this.lc_data.next_std_in_words;
      } else {
        this.show_promoted_standards = false;
      }
    },
    savegenLC() {
      const formData = {
        lid: this.registration_no.lid,
        progress: this.lc_data.progress,
        conduct: this.lc_data.conduct,
        remark: this.lc_data.remark,
        reason: this.lc_data.reason,
        gen_date: this.date_of_generation,
      };
      this.overlay = true;
      axios
        .post("/certificate/genLC", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_basic_data = res.data.org_basic_data;
            this.lc_data = res.data.lc_data;
            this.lc_data.last_school = this.org_basic_data.school_name;
            this.showSnackbar("green", "Success..!!!");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    proceed() {
      localStorage.setItem("lc_data", JSON.stringify(this.lc_data));
      localStorage.setItem(
        "org_basic_data",
        JSON.stringify(this.org_basic_data)
      );
      localStorage.setItem(
        "is_promoted_to_next_standard",
        JSON.stringify(this.is_promoted_to_next_standard)
      );
      localStorage.setItem(
        "Whether_failed_in_same_class",
        JSON.stringify(this.Whether_failed_in_same_class)
      );
      localStorage.setItem(
        "whether_ncc_cadet",
        JSON.stringify(this.whether_ncc_cadet)
      );
      let routeData = this.$router.resolve({ name: "sis-lc-print" });
      window.open(routeData.href, "_blank");
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    getColor(status) {
      if (status === "pending") return "red";
      if (status === "clear") return "green";
      if (status === "NA") return "gray";
    },

    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },

    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    onload() {
      this.ay_record = [];
      this.lc_data = null;
      this.org_basic_data = null;
      this.comp_load = true;
      axios
        .post("/admission/getAllStudents")
        .then((res) => {
          if (res.data.msg == "200") {
            this.stud_list = res.data.all_stud_list;
          } else {
            this.showSnackbar("red", "Something went wrong.");
          }
          this.comp_load = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.comp_load = false;
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    checkHistory() {
      console.log("registration_no:", this.registration_no);
      this.ay_record = [];
      this.lc_data = null;
      this.org_basic_data = null;
      if (this.registration_no == null) {
        this.showSnackbar("red", "Please select student");
      }
      this.overlay = true;
      axios
        .post("/certificate/checkHistory", this.registration_no)
        .then((res) => {
          console.log("res", res.data);
          if (res.data.flag == "YES") {
            this.ay_record = res.data.ay_record;
            this.account_status = res.data.account_status;
            this.ay_record_div = res.data.ay_record_div;
            this.dvt_prog = res.data.dvt_prog;
            this.progress = this.dvt_prog[0];
            this.dvt_conduct = res.data.dvt_conduct;
            this.conduct = this.dvt_conduct[0];
            this.dvt_reason = res.data.dvt_reason;
            this.reason = this.dvt_reason[0];
            this.dvt_remark = res.data.dvt_remark;
            this.remark = this.dvt_remark[0];
            this.condition = res.data.condition;
            this.standard_list = res.data.standard_list;
            if (!this.condition)
              this.showSnackbar("red", res.data.condition_msg);
          } else {
            this.showSnackbar("red", res.data.snackbar);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    genLC() {
      if (this.account_status == false) {
        if (
          !confirm(
            "Are You Sure You Want To generate LC as fees is pending...?"
          )
        )
          return;
      }
      if (
        this.progress != null &&
        this.conduct != null &&
        this.last_date_of_school != "" &&
        this.gen_date != "" &&
        this.remark != null &&
        this.reason != null &&
        this.application_date != "" &&
        this.issue_date != ""
      ) {
        const formData = {
          lid: this.registration_no.lid,
          progress: this.progress,
          conduct: this.conduct,
          remark: this.remark,
          reason: this.reason,
          last_date_of_school: this.last_date_of_school,
          gen_date: this.gen_date,
          date_of_application: this.application_date,
          date_of_issue: this.issue_date,
          mark_inactive: this.mark_inactive,
        };
        this.overlay = true;
        axios
          .post("/certificate/genLC", formData)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.org_basic_data = res.data.org_basic_data;
              this.lc_data = res.data.lc_data;
              this.lc_data.last_school = this.org_basic_data.school_name;
              // if (this.lc_data.caste == null) {
              //   alert("Caste is not enter ..");
              // }
              // this.showSnackbar("green", "User data fetched!!!");
            } else {
              this.showSnackbar("red", res.data.snackbar);
              sessionStorage.setItem("error-trace", res.data.error_trace);
            }
            this.overlay = false;
          })
          .catch((error) => {
            this.onerror(error);

            this.overlay = false;
          })
          .finally(() => {
            this.overlay = false;
          });
      } else {
        this.showSnackbar("red", "Please select/enter all data");
      }
    },
    fetchLC() {
      this.overlay = true;
      axios
        .post("/certificate/fetchLC", this.registration_no)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_basic_data = res.data.org_basic_data;
            this.lc_data = res.data.lc_data;
            this.lc_data.last_school = this.org_basic_data.school_name;
            this.date_of_application = this.formatDate(
              this.lc_data.date_of_application
            );
            this.date_of_issue = this.formatDate(this.lc_data.date_of_issue);

            // this.showSnackbar("green", "User data fetched!!!");
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
  mounted() {
    localStorage.setItem("lc_data", null);
    localStorage.setItem("org_basic_data", null);
    localStorage.setItem("last_date_of_school", "");
    this.onload();
    this.last_date_of_school = this.formatDate(this.date);
    this.gen_date = this.formatDate(this.date2);
    this.application_date = this.formatDate(this.date_of_application);
    this.issue_date = this.formatDate(this.date_of_issue);
    this.org_id = localStorage.getItem("EPS-org-id")
  },
};
</script>
<style scoped>
.scroll {
  overflow-x: scroll;
}
.mytable1 /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
.mytable /deep/ thead th {
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
  background: #83a4d4; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #265fb1,
    #b6fbff
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #265fb1,
    #b6fbff
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
tr,
td,
th {
  /* border: 1px solid #ccc; */
  text-align: center;
  font-size: small;
}
tr,
tbody {
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
.expapanel {
  width: 93%;
  margin-left: 3%;
}

.panelheader {
  /* background: linear-gradient(to right, #2c5364, #203a43, #0f2027); */
  color: white !important;
  background: #83a4d4; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #3792c7,
    #60e3eb,
    #a0dfe3
  ); /* Chrome 10-25, Safari 5.1-6 */
  /* background: linear-gradient(to right,  #83a4d4, #a0dfe3); W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  font-size: 16px;
  background: linear-gradient(to right, #3792c7, #60e3eb, #a0dfe3);
}
.fees span {
  font-size: 23px;
  font-weight: 600;
}
/* lc data css */
.printdiv {
  height: auto;
  margin-left: 15%;
  margin-right: 15%;
  background-color: rgb(248, 248, 241);
  background-position: center;
  padding: 0px 25px;
}
.heading {   
  font-family: "Times New Roman", Times, serif;
}
.underline {
    border-bottom: 1px solid black;
    display: inline-block;
    /* padding-bottom: 3px; */
    text-align: left;
}
.table-data td {
    font-size: medium;
    text-align: left;
}
.inside-header {
  border-right: 1px solid black;
  height: auto;
}
.header-row {
  padding-top: 15px;
}
.tdata2 {
    font-weight: bold;
}
.line-height{
  line-height: 200%;
}
.header-style {
  font-family: serif;
  color: rgb(151, 17, 17);
}
.header-style::first-letter {
  font-family: "GregorianFLF", serif;
  color: rgb(151, 17, 17);
}
.header-style .span-first-letter {
  font-family: "GregorianFLF", serif;
  color: rgb(151, 17, 17);
}
p {
  font-size: medium;
  margin: 0;
  font-weight: 600;
}
h1 {
  color: rgb(151, 17, 17);;
}
/* lc data css end */

/* print lc css */
@media print {
  .pagebreak {
    page-break-before: always;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  v-card {
    border: none !important;
  }
  .printdiv {
    margin: 0;
    padding: 0;
  }
  .line-height {
    line-height: 200% !important;
    font-size: 20px !important;
  }
  #document1 {
    position: absolute;
    margin-top: -63px;
    margin-left: -12px;
    top: 0;
    /* left: 0;
    right: 0; */
    bottom: 0;
  }
  .header-style {
    font-size: 40px;
  }
  p, .tdata2  {
    font-size: 20px;
  }
  @page {
    size: A4;
    margin: none;
    margin-top: 40px !important;
    padding-top: none;
    size: 11.5in 16.5in;
  }
}
/* print lc css end */

span.stretch {
  display: inline-block;
  -webkit-transform: scale(1.5, 1); /* Safari and Chrome */
  -moz-transform: scale(1.3, 1); /* Firefox */
  -ms-transform: scale(1.5, 1); /* IE 9 */
  -o-transform: scale(1.5, 1); /* Opera */
  /* transform: scale(1.3,1); */
  /* margin-left: 25%; */
  font-size: 14px;
}
.stretch1 {
  display: inline-block;
  -webkit-transform: scale(1.3, 1); /* Safari and Chrome */
  -moz-transform: scale(1.3, 1); /* Firefox */
  -ms-transform: scale(1.5, 1); /* IE 9 */
  -o-transform: scale(1.5, 1); /* Opera */
  /* transform: scale(1.3,1); */
  /* margin-left: 25%; */
  font-size: 14px;
}

h3.stretch2 {
  display: inline-block;
  -webkit-transform: scale(2, 1); /* Safari and Chrome */
  -moz-transform: scale(1.5, 1); /* Firefox */
  -ms-transform: scale(1.5, 1); /* IE 9 */
  -o-transform: scale(1.5, 1); /* Opera */
}
</style>